export const FORM_TYPES = Object.freeze({
  LOGIN: "login",
  REGISTER: "register",
  FORGOTTEN_PASSWORD: "forgoten_password",
  CONFIRM_TARGET_GROUP: "confirm_target_group",
});

export const DEFAULT_USER = Object.freeze({
  id: 0,
  email: "",
  firstName: "",
  lastName: "",
  role: "",
  isVerified: false,
  jwtToken: "",
  expires: 0,
});

export const TARGET_GROUPS = Object.freeze({
  values: [
    { value: 1, text: "Fizička osoba" },
    {
      value: 2,
      text: "Izvođač",
      children: [
        { value: 3, text: "Izvođač suha gradnja" },
        { value: 4, text: "Izvođač žbuker" },
        { value: 5, text: "Izvođač fasader" },
        { value: 6, text: "Izvođač keramičar" },
      ],
    },
    { value: 7, text: "Arhitekt" },
    { value: 8, text: "Investitor" },
  ],
  getText(selectedValue: number) {
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i].value === selectedValue) {
        return this.values[i].text;
      } else if (this.values[i] && this.values[i]!.children && this.values[i].children!.length > 0) {
        for (let j = 0; j < this.values[i].children!.length; j++) {
          if (this.values[i].children![j].value === selectedValue) {
            return this.values[i]?.children![j].text;
          }
        }
      }
    }
  },
  getValue(selectedText?: string | null | undefined) {
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i].text === selectedText) {
        return this.values[i].value;
      } else if (this.values[i] && this.values[i]!.children && this.values[i].children!.length > 0) {
        for (let j = 0; j < this.values[i].children!.length; j++) {
          if (this.values[i].children![j].text === selectedText) {
            return this.values[i]?.children![j].value;
          }
        }
      }
    }
  },
  combineValues() {
    let res: any = [];
    TARGET_GROUPS.values.forEach((element) => {
      if (element.children) {
        element.children.forEach((childElement) => {
          res.push({ value: childElement.value, text: childElement.text });
        });
      } else {
        res.push({ value: element.value, text: element.text });
      }
    });
    return res;
  },
});
